import { type VariantProps } from 'class-variance-authority';

import { avatarStyles } from './Avatar.styles';

import { cn } from '@/lib/cn';

/** Under five props and no reused type, so no `types.ts` — the short form. */
interface AvatarProps extends VariantProps<typeof avatarStyles> {
  /** `null` falls back to the initials, never a broken image. */
  src?: string | null;
  name: string;
  className?: string;
}

/** "Marie Dupont" becomes "MD"; "Camille" becomes "SK". */
function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return parts.length > 1
    ? `${parts[0][0]}${parts[1][0]}`
    : name.slice(0, 2).padEnd(1, '');
}

export function Avatar({ src, name, size, className }: Readonly<AvatarProps>) {
  return (
    <span
      className={cn(avatarStyles({ size }), className)}
      // The avatar always doubles a name already displayed, so announcing it
      // again would be noise.
      aria-hidden
    >
      {src ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          className="size-full object-cover"
        />
      ) : (
        initials(name)
      )}
    </span>
  );
}
